import { Instagram, Facebook, Youtube, Music2 } from "lucide-react";
import { telHref } from "../../lib/site";

export const Footer = ({ content }) => {
  const socials = [
    ["instagram", content.social_instagram, Instagram, "Instagram"],
    ["facebook", content.social_facebook, Facebook, "Facebook"],
    ["tiktok", content.social_tiktok, Music2, "TikTok"],
    ["youtube", content.social_youtube, Youtube, "YouTube"],
  ].filter((s) => s[1]);
  return (
    <footer data-testid="public-footer" className="relative bg-[#000000] border-t border-[#D4AF37]/15 pt-20 pb-28 sm:pb-12">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="grid md:grid-cols-[1.3fr_1fr_1fr] gap-12">
          <div>
            <img src="/img/logo-t.png" alt="Vienna Palace Hotel" data-testid="footer-logo" className="h-20 w-auto" loading="lazy" />
            {content.footer_text && <p className="mt-6 text-sm text-zinc-400 leading-relaxed max-w-sm whitespace-pre-line" data-testid="footer-text">{content.footer_text}</p>}
          </div>
          <div className="text-sm text-zinc-400 leading-relaxed">
            <p className="font-caps text-[10px] text-[#D4AF37] mb-4">Endereço</p>
            <p>{content.address_street}<br />{content.address_district} · {content.address_city} — {content.address_state}<br />CEP {content.address_cep}</p>
          </div>
          <div className="text-sm text-zinc-400">
            <p className="font-caps text-[10px] text-[#D4AF37] mb-4">Reservas</p>
            <a href={telHref(content.phone)} className="hover:text-[#E6C687] block">{content.phone}</a>
            {content.email && <a href={`mailto:${content.email}`} className="hover:text-[#E6C687] block mt-1 break-all">{content.email}</a>}
            {socials.length > 0 && (
              <div className="flex gap-3 mt-6">
                {socials.map(([k, url, Icon, label]) => (
                  <a key={k} href={url} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={`footer-social-${k}`} className="h-10 w-10 grid place-items-center rounded-full border border-zinc-700 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                    <Icon size={16} />
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="gold-line mt-16" />
        <div className="mt-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} Vienna Palace Hotel. Todos os direitos reservados.</span>
          {content.footer_note && <span data-testid="footer-note">{content.footer_note}</span>}
        </div>
      </div>
    </footer>
  );
};
